import axios from 'axios';
import { URL as API_URL } from '../config/api';
import { getBearer } from '../services/user';

const LOCATION_HEADERS = ['location', 'content-location'];

const instance = axios.create({ baseURL: API_URL });

instance.interceptors.request.use(config => ({
  ...config,
  headers: {
    ...config.headers,
    Authorization: `Bearer ${getBearer()}`
  }
}));

export default instance;

export function followRedirect(response) {
  const locationHeader = Object.keys(response.headers)
    .find(h => LOCATION_HEADERS.includes(h));

  return locationHeader === -1 ? response : instance.get(response.headers[locationHeader]);
}

